/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { RxStomp, RxStompConfig,  } from '@stomp/rx-stomp';
import { from } from 'rxjs';

export class GenericStompConnection extends RxStomp {
    private readonly url: string;
    private token: string;
    constructor(url: string, token: string ) {
        super();
        this.url = url;
        this.token = token;
        this.configure(this.getConfiguration(url, token));
    }

    setConnection() {
        let configuration = this.getConfiguration(this.url, this.token);
        console.info(`Updating websocket configuration ${configuration.brokerURL}`);
        let hasNewBroker = this.stompClient.brokerURL !== configuration.brokerURL;
        this.configure(configuration);
        console.info(`Activating websocket: ${this.stompClient.brokerURL}`);
        this.activate();
    }

    private getConfiguration(url: string, token: string): RxStompConfig {
        let brokerUrl = new URL('/api/spring-websocket', url);
        brokerUrl.protocol = brokerUrl.protocol.replace('https', 'wss');
        brokerUrl.protocol = brokerUrl.protocol.replace('http', 'ws');
        return {
            brokerURL: brokerUrl.href,
            connectHeaders: {
                'X-Bearer-Token': `${token}`
            },
            reconnectDelay: 10000,
            heartbeatIncoming: 5000,
            heartbeatOutgoing: 5000
        };
    }

    public connectWebSocket() {
        if (!this.connected()) {
            console.info(`Activating websocket`);
            this.activate();
        }
    }

    public disconnectWebSocket() {
        console.info(`Deactivating websocket`);
        this.deactivate().then();
    }

    updateToken(token: string) {
        this.token = token;
        this.configure(this.getConfiguration(this.url, this.token));
    }
}
